const MAP = {
  requested: ["Waiting for host", "bg-amber-50 text-amber-800 border-amber-200"],
  accepted: ["Accepted · awaiting payment", "bg-sky-50 text-sky-800 border-sky-200"],
  confirmed: ["Confirmed", "bg-emerald-50 text-emerald-800 border-emerald-200"],
  completed: ["Completed", "bg-stone-100 text-stone-700 border-stone-200"],
  declined: ["Declined", "bg-red-50 text-red-800 border-red-200"],
  cancelled: ["Cancelled", "bg-stone-100 text-stone-500 border-stone-200"],
  open: ["Waiting for host reply", "bg-amber-50 text-amber-800 border-amber-200"],
  host_responded: ["Under admin review", "bg-sky-50 text-sky-800 border-sky-200"],
  resolved: ["Resolved", "bg-emerald-50 text-emerald-800 border-emerald-200"],
  dismissed: ["Dismissed", "bg-stone-100 text-stone-700 border-stone-200"],
  partial_refund: ["Partial refund", "bg-sky-50 text-sky-800 border-sky-200"],
  full_refund: ["Full refund", "bg-red-50 text-red-800 border-red-200"],
  pending: ["Awaiting approval", "bg-amber-50 text-amber-800 border-amber-200"],
  approved: ["Approved", "bg-emerald-50 text-emerald-800 border-emerald-200"],
  rejected: ["Needs changes", "bg-red-50 text-red-800 border-red-200"],
};

export default function StatusBadge({ status, testid }) {
  const [label, cls] = MAP[status] || [status, "bg-stone-100 text-stone-700 border-stone-200"];
  return <span data-testid={testid} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}>{label}</span>;
}

export const bookingState = (b) => (b.completed ? "completed" : b.status);
